import root from 'window-or-global';
import {generateRoutePath} from '@epic-core/common';
import {ProductInstallState, ProductBridge, DLCState} from '../productBridge';

const productWeb: ProductBridge = {
    getInstalledApps: async (): Promise<ProductInstallState[]> => await [],

    getApp: async (
        namespace: string,
        catalogId: string,
        appName: string
    ): Promise<ProductInstallState> => {
        return await {
            namespace,
            catalogid: catalogId,
            appname: appName,
            isinitialized: true,
            isinstalled: false,
            hasoptionalinstalls: false,
            isrunning: false,
            ispartiallyinstalled: false,
            isupdating: false,
            iscorrupt: false,
            iswaitinginline: false,
            isinupdatequeue: false,
            updatestatus: '',
            hasupdate: false,
            progress: 0,
            retrytime: '',
            waittime: '',
            installedversion: '',
            installalerttext: '',
            installalertverbosity: '',
            serverstatus: '',
            serverstatustext: '',
            installsizeondisk: 0,
            neverupdate: false,
            isbanned: false,
            isreadytoinstall: false
        };
    },

    install: async (_namespace: string, _catalogId: string, appName: string): Promise<boolean> => {
        root.location.href = generateRoutePath(`install${appName ? `/${appName}` : ''}`);
        return await true;
    },
    uninstall: async (): Promise<boolean> => await false,
    update: async (): Promise<boolean> => await false,
    pauseInstallation: async (): Promise<boolean> => await false,
    resumeInstallation: async (): Promise<boolean> => await false,
    cancelInstallation: async (): Promise<boolean> => await false,
    launch: async (): Promise<boolean> => await false,
    cancelWaitingRoom: async (): Promise<boolean> => await false,
    showInstallerOptions: async (): Promise<boolean> => await false,
    verifyInstallation: async (): Promise<boolean> => await false,
    createShortcut: async (): Promise<boolean> => await false,
    getGlobalAutoUpdate: async (): Promise<boolean> => await false,
    setAutoUpdate: async (): Promise<boolean> => await false,
    getAutoUpdate: async (): Promise<boolean> => await false,
    setCloudSave: async (): Promise<boolean> => await false,
    getCloudSave: async (): Promise<boolean> => await false,
    syncCloudSave: async (): Promise<boolean> => await false,
    getRecentlyPlayed: async (): Promise<ProductInstallState[]> => await [],
    registerResponseCallback: async (): Promise<void> => await undefined,
    goToInstallAlert: async (): Promise<boolean> => await false,
    refetchUserBuilds: async (): Promise<boolean> => await false,
    setAppConfiguration: async (): Promise<boolean> => await false,
    getAppConfiguration: async (): Promise<DLCState[]> => await []
};

export default productWeb;
